import React from 'react'
import {Grid, GridCell, Section, Icon, Message, css, Progress, PopupHint, Separator,Button, Heading, Div, Theme, Placeholder, } from '@bdfx/mergado-ui-kit'
import ReactApexChart from 'react-apexcharts'
import {colord} from "colord"


interface Props {
}

class HomePage extends React.PureComponent<Props, {}> {
    chart = {
          
        series: [44, 55, 13, 43],
        options: {
          chart: {
            width: 380,
            type: 'pie' as "pie",
          },
          labels: ['Without problem', 'Unsupported format', 'Status unavailable', 'Missing images'],
          colors: ["#00e396", colord(Theme.red).lighten(0.2).toRgbString(),colord(Theme.red).lighten(0.1).toRgbString(), Theme.red],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: { 
                position: 'bottom'
              }
            }
          }]
        },
      
      
      };


    render() {
        return (
            <Style cols="1fr 1fr 1fr 1fr 1fr 1fr" gap="20px">

                <GridCell col="span 4">
                    <Section header={<div>Messages <Icon type="bell-light" style={{float: "right"}} /></div>} className="messages">
                        <Grid cols="1fr 1fr" gap="10px">
                            <Message icon={<Icon type="book-opened-light"  color="blue" size={30} />} closeable={true}>
                                Learn to use Feed Image Editor flawlessly. Sign up for the free image marketing workshop. <a href="#">Find out more.</a>
                            </Message>
                            <Message icon={<Icon type="info-light" color="blue" size={30} />} closeable={true}>            
                                If you have multiple templates for the same products, only the highest priority template is applied. You can assign products for each template when editing the template on the <a href="#">Products tab.</a>
                            </Message>
                        </Grid>
                    </Section>
                </GridCell>
                <GridCell col="span 2">
                    <Section header={<div>In progress <Icon type="hourglass-light" style={{float: "right"}}></Icon></div>}>
                        <Grid cols="auto 1fr" gap="10px" valign="center" align="left">
                            <PopupHint icon={<Progress value={1320 * 100 / 1832} max={1832} height={"20px"} width={"80px"} showLabel={true}  getValueLabel={() => "60 %"} />}
                            >1 320 / 1 832 produktů</PopupHint>
                            <span><a href="#">Šablona s dlouhým názvem</a></span>
                            <PopupHint icon={<Progress value={50} max={210} height={"20px"} width={"80px"} showLabel={true}  getValueLabel={(value) => value + " %"} />}
                            >40 / 210 produktů</PopupHint>
                            <span><a href="#">Šablona II.</a></span>
                            <GridCell col="span 2"><Separator orientation="horizontal" margin="5px 0 0" /></GridCell>
                            <Progress value={100} max={100} height={"20px"} color="success" width={"80px"} showLabel={true}  getValueLabel={(value) => value + " %"} /> 
                            <a href="#">30 templates done</a>
                        </Grid>    
                    </Section>
                </GridCell>
                <GridCell col="span 3">
                    <Section header={<div>Diagnostics <Icon style={{float: "right"}} type="stethoscope" /></div>}>
                        <Grid cols="1fr auto" valign="center" className="checklist">
                            <Heading type={5}>Project settings</Heading>
                            <GridCell align="center"><Icon type="close-light" color="red" /></GridCell>
                            <GridCell col="1 / -1">
                            <ul style={{display: "grid", gridGap: "5px", }}>
                                <li>Input element missing <Button color="red" size="smaller" style={{float: "right"}}>Fix</Button></li>
                                <li>No products found <Button color="warning" size="smaller" style={{float: "right"}}>Check</Button></li>
                            </ul>                            
                            </GridCell>
                        </Grid>

                        <Separator orientation="horizontal" margin="5px 0 20px 0" />

                        <Grid cols="1fr 1fr">
                            <GridCell>
                                <Heading type={5}>Overview</Heading>
                                <div>
                                    <ul>
                                        <li><Icon type="box-light">1 230 products</Icon></li>
                                        <li><Icon type="no-entry-light" color="red">834 problems</Icon></li>
                                        <li><Icon type="danger-light" color="orange">201 warnings</Icon></li>
                                        <li><Icon type="info-light" color="blue">412 suggestions</Icon></li>
                                    </ul>
                                </div>
                            </GridCell>
                            <GridCell>
                                <Heading type={5}>Problems</Heading>
                                <div id="chart" style={{position: "relative"}}>
                                    <ReactApexChart options={this.chart.options} series={this.chart.series} width="380" type={"pie" as "pie"} />
                                </div>
                            </GridCell>
                        </Grid>

                    </Section>
                </GridCell>

                <GridCell col="span 3" color="red">
                    <Section header={<div>News <Icon style={{float: "right"}} type="rss-light" size={18} /></div>}>
                        <Heading type={5}>Latest release <small style={{float: "right", fontWeight: "normal"}}>🗓️ 23. srpna 2023, 10:54</small></Heading> 

                        <Div>
                            <div>                                
                                <ul>
                                    <li>optimalizace synchronizace s Mergadem</li>
                                    <li>nahledy: data pro produkty z MergadoAPI nacitame z <code>value</code> namisto <code>input_value</code> (mimo elementu pro obrazky a alt. obrazky)</li>
                                    <li>uprava UI pro editaci gradientu, preddefinovane gradienty</li>
                                    <li>refactory a updates</li>
                                    <li> autocrop image (ořeže produktový obrázek, pokud je bgremove nebo wmremove oreže i ten, platí i pro koláže)</li>
                                </ul>
                            </div>
                        </Div>
                        <Separator orientation="horizontal" margin="5px 0" />
                        <Heading type={5} style={{margin: "15px 0 !important"}}>Blog</Heading>
                        <Grid cols="1fr auto" valign="top" gap="10px">
                            <a href="#">AI nástroj pro hromadné a automatické odstraňování vodoznaků z produktových obrázků</a>
                            <small> 🗓️ 23. 08. 2023, 10:54</small>
                            <a href="#">Snadný způsob inzerce produktových obrázků: autodíly</a>
                            <small> 🗓️ 31. 07. 2023, 14:44</small>
                            <a href="#">Snadný způsob propagace obrázků produktů: lékárna</a>
                            <small> 🗓️ 31. 06. 2023, 12:21</small>
                        </Grid>
                        
                    </Section>
                </GridCell>



                <GridCell col="span 6">
                    <Section header={<div>Showroom <Icon type="image-light" style={{float: "right"}} /></div>}>
                        <Div overflowX="auto">
                        <Grid autoFlow="column" gap="10px">
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                            <Placeholder aspectRatio={1} width="200px" />
                        </Grid>
                        </Div>
                    </Section>  
                </GridCell>

            </Style>
        )
    }
}

const Style = css(Grid)({
    ".muk-heading-wrapper": {
        marginBottom: 0,
    },
    ".messages": {
        ".muk-message__content": {
            fontSize: "13px",
        },
    },
    "section": {
        marginBottom: 0,
        height: "100%",
        background: "white",
    },
    ".checklist": {
    },
    "small": {
        fontSize: "13px",
    },
    "ul": {
        paddingLeft: "10px",
    },
    "li": {
        fontSize: "13px",
        marginBottom: "5px",
    },
    "li::marker": {
        content: "'• '",
        color: "#ccc",
        paddingRight: "10px",
    },
})

export default HomePage